/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import { paragraphSmall, weightSemiBold } from 'src/components/css'

export interface DetailField {
  label: string
  value: string
  isUnset?: boolean
}

/** Read-only field grid. Editing happens in the entity's own modal. */
const EntityDetailsTab = ({ fields }: { fields: DetailField[] }) => {
  'use memo'

  return (
    <dl css={gridStyle}>
      {fields.map((field) => (
        <div key={field.label} css={fieldStyle}>
          <dt css={labelStyle}>{capitalizeWords(field.label)}</dt>
          <dd css={valueStyle(Boolean(field.isUnset))}>{field.value}</dd>
        </div>
      ))}
    </dl>
  )
}

const gridStyle = css`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: 1px;
  margin: 0;
  background: ${colors.SECONDARY_300};
  border: 1px solid ${colors.SECONDARY_200};
  border-radius: 8px;
  overflow: hidden;
`

const fieldStyle = css`
  background: ${colors.SECONDARY_400};
  padding: 11px 14px;
`

const labelStyle = css`
  ${weightSemiBold}
  font-size: 10px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: ${colors.NEUTRAL_100};
  margin-bottom: 4px;
`

const valueStyle = (isUnset: boolean) => css`
  ${paragraphSmall}
  margin: 0;
  font-variant-numeric: tabular-nums;
  font-style: ${isUnset ? 'italic' : 'normal'};
  color: ${isUnset ? colors.NEUTRAL_100 : colors.NEUTRAL_0};
`

export default EntityDetailsTab
